var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0922 0.462402C13.7702 0.462493 13.4593 0.579835 13.2179 0.792383C12.9765 1.00493 12.8213 1.29806 12.7814 1.61668L12.1101 6.95853H25.8899L25.2186 1.61668C25.1787 1.29806 25.0235 1.00493 24.7821 0.792383C24.5407 0.579835 24.2298 0.462493 23.9078 0.462402H14.0922ZM26.4766 10.2501C26.4388 10.2523 26.4009 10.2531 26.363 10.2527H11.637L11.5234 10.2501H6.72921C3.2935 10.2501 0.5 13.0172 0.5 16.4432V26.0964C0.5 30.147 4.30836 33.0511 8.20393 32.3606C11.5022 31.773 15.5511 31.2195 19 31.2195C22.4489 31.2195 26.4978 31.773 29.7961 32.3606C33.6916 33.0511 37.5 30.147 37.5 26.0964V16.4405C37.5 13.0146 34.7065 10.2474 31.2708 10.2474L26.4766 10.2501ZM9.98521 18.9098C9.98521 18.0006 10.7252 17.2627 11.637 17.2627H26.363C26.8011 17.2627 27.2212 17.4363 27.531 17.7452C27.8408 18.0541 28.0148 18.473 28.0148 18.9098C28.0148 19.3467 27.8408 19.7656 27.531 20.0745C27.2212 20.3834 26.8011 20.5569 26.363 20.5569H11.637C11.1989 20.5569 10.7788 20.3834 10.469 20.0745C10.1592 19.7656 9.98521 19.3467 9.98521 18.9098Z",
    fill: "#E0861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/Simulation.5850220a763a7ffd28e25d8a9b1afe42.svg";
export { ForwardRef as ReactComponent };